import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ApiService } from '@core/services/api.service';
import { SessionService } from '@core/services/session.service';
import { Platform } from '@ionic/angular';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class VersionGuard implements CanActivate {
  url = environment.apiUrl;
  constructor(private _session: SessionService, private _api: ApiService, private _platform: Platform, private router: Router, private http: HttpClient) {
  }
  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (Capacitor.getPlatform() == 'web') {
      return true;
    }
    try {
      const versions = await firstValueFrom(this._session.versions);
      const backendVersions = await lastValueFrom(this.http.get<any>(`${this.url}/login/version`, { headers: { jwt: this._session.getSession().jwt } }));
      const platformIsAndroid = this._platform.is('android');
      const currentVersion = platformIsAndroid ? versions.android : versions.ios;
      const versionToCheck = platformIsAndroid ? backendVersions.androidVersion : backendVersions.iosVersion;
      if (versionToCheck > currentVersion) {
        await this.router.navigate(['/update']);
        return false;
      } else {
        return true;
      }
    } catch (e) {
      console.log(`Error al consultar version, ${e}`);
      return true;
    }
  }
}
